import React from "react";
import "./Movie.css";
import { Link } from "react-router-dom";

function Movie({ movie }) {
  return (
    <>
      <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 mb-5">
        <Link className="movie-link" to={`/movie/${movie.id}`}>
          {movie.poster_path === null ? (
            <>
              <p className="movie-not-found-title">{movie.title}</p>
              <img
                className="movie-poster-not-found"
                src="../not-found-image.png"
                alt={movie.title}
              />
            </>
          ) : (
            <img
              className="movie-poster"
              src={`https://image.tmdb.org/t/p/w500${movie.poster_path}`}
              alt={movie.title}
            />
          )}
        </Link>
      </div>
    </>
  );
}

export default Movie;
